import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

interface UseInitialMessageProps {
  conversationId?: string;
  sendMessage: (message: string) => void;
}

export const useInitialMessage = ({ conversationId, sendMessage }: UseInitialMessageProps) => {
  const location = useLocation();
  const initialMessageProcessedRef = useRef(false);

  useEffect(() => {
    // Skip if we've already processed an initial message
    if (initialMessageProcessedRef.current) {
      return;
    }

    // Try to get message from location state first
    let initialMessage = "";

    if (
      location.state &&
      typeof location.state === "object" &&
      "initialMessage" in location.state
    ) {
      initialMessage = (location.state as { initialMessage: string }).initialMessage;
      console.log("Found message in location state:", initialMessage);
    }

    // If not in location state, try localStorage as fallback
    if (!initialMessage && conversationId) {
      initialMessage = localStorage.getItem(`message_${conversationId}`) || "";
      console.log("Found message in localStorage:", initialMessage);

      // Clean up localStorage after retrieving
      if (initialMessage) {
        localStorage.removeItem(`message_${conversationId}`);
      }
    }

    // Process the initial message if we found one
    if (initialMessage) {
      initialMessageProcessedRef.current = true;
      // Small timeout to ensure component is fully mounted
      setTimeout(() => {
        sendMessage(initialMessage);
      }, 100);
    }
  }, [conversationId, location.state, sendMessage]);

  return {
    hasProcessedInitialMessage: initialMessageProcessedRef.current,
  };
}; 